import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IShortformSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const ShortformSection = styled.div<IShortformSectionProps>`
  ${({ $bgColor, $textColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .main-title,
      .btn-section-more {
        color: ${$textColor};
      }
    `}
  padding: 32px 0;
  text-align: center;

  &.bg-type-white {
    background: #fff;
  }

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }

    .btn-section-more {
      color: #fff;
      border-color: #555;
    }
  }

  .swiper-slide {
    width: 80% !important;
  }

  .skeleton-list {
    ${mixin.flex({ justify: 'flex-start' })};
    gap: 0 10px;
    padding-left: 20px;
    overflow: hidden;

    .shortform-item-skeleton {
      flex-shrink: 0;
    }
  }

  .btn-section-more {
    margin: 20px auto 0;
    background: transparent;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .skeleton-list {
      gap: 0 ${mixin.pxToVw('10')};
      padding-left: ${mixin.pxToVw('20')};
    }

    .btn-section-more {
      margin: ${mixin.pxToVw('20')} auto 0;
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 0;

    .section-title,
    .items-swiper,
    .skeleton-list {
      width: var(--pc-width);
      margin: 0 auto;
    }

    .swiper-button-prev,
    .swiper-button-next {
      visibility: visible;
      opacity: 1;
    }

    .swiper-slide {
      width: 318px !important;
      height: 607px;
    }

    .skeleton-list {
      padding: 0;
      gap: 0 18px;
    }

    .btn-section-more {
      width: 430px;
      margin-top: 48px;
    }
  }
`;
